import React, {useState, useRef, useEffect} from 'react'
import Loading from '../general/Loading';
import Camera from '../assets/camera-img.png';
import BannerBg from '../assets/banner2-bg.jpg';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = ({userData, setResponse}) => {
  const navigate = useNavigate();
              const [orders, setOrders] = useState([]);
  
const [showAdd, setShowAdd] = useState(false);
  const [banners, setBanners] = useState([]);
  const [showDeleteOffer, setShowDeleteOffer] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState('');
      const [coupon, setCoupon] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        tagline: '',
        description: '',
        offerImage: null
    });
 const fetchBanners = async () => {
      try {
        const response = await fetch('https://api.hargharmart.com/get-banner');
        // console.log(response);
        if (response.ok) {
          const data = await response.json();
          setBanners(data);
          console.log(data);
        } else {
          console.error('Failed to fetch banners');
        }
      } catch (error) {
        console.error('Error fetching banners:', error);
      }
    };
           const fetchCoupon = async () => {
                try {
                    const response = await fetch('https://api.hargharmart.com/get-coupon');
    
                    if (response.ok) {
                        const data = await response.json();
                        setCoupon(data);
                    } else {
                        console.error('Failed to fetch coupon');
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            };
                    const fetchOrders = async () => {
                        setLoading(true);
                        try {
                            const response = await fetch('https://api.hargharmart.com/get-orders');
            
                            if (response.ok) {
                                const data = await response.json();
                                console.log(data);
// const sortedOrders = data.sort((a, b) => new Date(b.order_date) - new Date(a.order_date));
           const mostDemanded = getMostInDemandProducts(data);
                               setOrders(mostDemanded);
                                setLoading(false);
                            } else {
                                setLoading(false);
                                console.error('Failed to fetch users');
                            }
                        } catch (error) {
                            setLoading(false);
                            console.error('Error fetching data:', error);
                        }
                    };


  useEffect(() => {
   

           
    
                
                    fetchOrders();
            fetchCoupon();
    fetchBanners();
  }, [])

    const [imagePreview, setImagePreview] = useState(null);


    const fileInputRef = useRef(null);
    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    const handleChange = (e) => {
        const { id, value, type, files } = e.target;
        if (type === 'file') {
            setFormData({
                ...formData,
                [id]: files[0]
            });
            // Update image preview
            const file = files[0];
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            if (file) {
                reader.readAsDataURL(file);
            }
        } else {
            setFormData({
                ...formData,
                [id]: value
            });
        }
    };


    const handleOfferSubmit = async (e) => {
        e.preventDefault();

        if(formData.offerImage == null){
                            setResponse('Add Offer Image!');
                setTimeout(() => {
                    setResponse('');
                }, 2000);
return;
        }

        setLoading(true);

        const formDataToSubmit = new FormData();
        Object.keys(formData).forEach((key) => {
            formDataToSubmit.append(key, formData[key]);
        });


        try {
            const response = await fetch('https://api.hargharmart.com/add-banner', {
                method: 'POST',
                body: formDataToSubmit
            });

            setLoading(false);

            if (response.ok) {
      setResponse({ message: 'Banner Added successfully.', status: 'success' });
      setTimeout(() => setResponse(''), 2000);
                setShowAdd(false);
                setFormData({
                    name: '',
                    tagline: '',
                    description: '',
                    offerImage: null
                });
            } else if (response.status == 400) {
                setLoading(false);
                    setResponse({ message: 'Unable to Add Banner.', status: 'error' });
      setTimeout(() => setResponse(''), 2000);
            }
            fetchBanners();
        } catch (error) {
            setLoading(false);
            console.error('Error adding offer:', error);
        }
    };


const handleDeleteOfferDialog = (offer) => {
  setShowDeleteOffer(true);
  setSelectedOffer(offer);
}

const handleDeleteOffer = async (offerId) => {
  setLoading(true);

  try {
      const response = await fetch(`https://api.hargharmart.com/delete-banner/${offerId}`, {
          method: 'DELETE',
      });

      setLoading(false);

      if (response.ok) {
              setResponse({ message: 'Banner removed successfully!', status: 'success' });
          setTimeout(() => {
              setResponse('');
              window.location.reload();
          }, 1500);
          setShowDeleteOffer(false);
      } else {
          setLoading(false);
      setResponse({ message: 'Unable to Remove Banner.', status: 'error' });
          setTimeout(() => {
              setResponse('');
          }, 2000);
          setShowDeleteOffer(false);
      }
  } catch (error) {
      setLoading(false);
      console.error('Error deleting Offer:', error);
  }
};


  const getMostInDemandProducts = (orders) => {
    const productMap = new Map();
  
    orders.forEach(order => {
      const items = JSON.parse(order.order_items);
  
      items.forEach(item => {
        const productId = item.id;
  
        if (productMap.has(productId)) {
          const existing = productMap.get(productId);
          existing.quantity += item.item_qty;
          existing.count += 1;
          productMap.set(productId, existing);
        } else {
          productMap.set(productId, {
            product_id: productId,
            product_name: item.name,
            image: item.image,
            quantity: item.item_qty,
            brand: item.brand,
            // category: item.category,
            // subCategory: item.sub_category,
            count: 1
          });
        }
      });
    });
  
    // Convert map to array and sort by total quantity or order count
    const sortedProducts = Array.from(productMap.values())
      .sort((a, b) => b.quantity - a.quantity);
  
    return sortedProducts;
  };
  

  return (
    <>
    <section className='my-4'>
      <div className='px-4'>
        <div className='d-flex justify-content-between'>
          <p className='page-title'>{userData.user_name} <i class="fa-solid fa-store"></i></p>
        </div>


<div className='row'>

<div className='col-lg-8 col-12 my-2'>
  <div className='text-end mb-2'>
          <button className='edit-btn' onClick={() => setShowAdd(true)}>Add Banner</button></div>
              <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel" data-bs-interval="2000">
    <div className="carousel-indicators">
        {banners.length > 0 &&
            banners.map((offer, index) => (
                <button
                    key={index}
                    type="button"
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide-to={index}
                    className={`bg-light ${index === 0 ? 'active' : ''}`}
                    aria-label={`Slide ${index + 1}`}
                ></button>
            ))
        }
    </div>

    <div className="carousel-inner">
        {banners.length > 0 ? (
            banners.map((offer, index) => {
                const offerUrl = `https://api.hargharmart.com/uploads/${offer['image']}`;
                return (
                  <>
                    <div
                        key={index}
                        className={`carousel-item text-light align-content-center ${index === 0 ? 'active' : ''} dashboard-bg`}
                        style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.10), rgba(0, 0, 0, 0.46)), url(${offerUrl || BannerBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  }}
                    >
                        <div className="container">
                            <p className="banner-text fw-semibold">{offer.offer_tagline}</p>
                            <p className="banner-heading col-md-8">{offer.offer_name}</p>
                            <p className="col-lg-6 col-md-8 fm-spartan">{offer.description}</p>
                            <button className='edit-btn bg-white text-black' onClick={() => handleDeleteOfferDialog(offer)}>Remove ❌</button>
                        </div>
                    </div>
                    </>
                );
            })
        ) : (
            <div className="carousel-item text-light active dashboard-bg" style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.10), rgba(0, 0, 0, 0.46)), url(${BannerBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  }}>
                <div className="container">
                    <p className="banner-text fw-semibold">Your Offer Tagline</p>
                    <p className="banner-heading col-md-8">Offer Name will be shown here</p>
                    <p className="col-lg-6 col-md-8 fm-spartan">
                      Add Description of your offer
                    </p>
                </div>
            </div>
        )}
    </div>
</div>

</div>

<div className='col-lg-4 col-12 my-2'>
  <div className='bg-white px-3 py-3 rounded-3'>
<div className='d-flex justify-content-between'>
<span className='category-text'>Exciting Coupons</span>
          <span className='text-blue para-text fw-semibold cursor-pointer' onClick={() => navigate('/added-coupons')}>View All</span></div>
<hr />

              {coupon.slice(0,3).map(product => (
                <div className='col-12 mb-3'>
                  <div className='coupon-area'>

<div>
<p className='fw-semibold'>{product.code}</p>
<p className='para-text mb-0'>{product.name}<br />{product.discount_type == 'amount' && '₹'}{product.amount}{product.discount_type == 'percent' && '%'}</p>
<span className='para-text'>(Minimum Order Value of ₹{product.order_value})</span>

</div>

{/* <div className='align-content-center text-center my-2'>
<span className='ms-2 close-btn bg-light text-dark' onClick={() => handleShowDelete(product)}>Remove <i class="fa-solid fa-xmark"></i></span>    
    </div> */}

</div>
</div>

              ))}

</div>
</div>

</div>
{/* row ends */}

  <div className="my-5">
    <p className='fs-5 fw-bold'>In Demand Products</p>
<hr />

    {orders.length === 0 ? (
      <p>No demand data available.</p>
    ) : (
      <div className="row">
        {orders.slice(0, 20).map(product => (
          <div
            key={product.product_id}
            className="col-md-3 col-sm-4 col-6 my-2"
          >

            <div className="bg-white rounded-2 p-3">
              <p className="card-title fw-semibold text-truncate">{product.product_name}</p>
              <p className='fm-spartan'>Quantity Sold: {product.quantity}</p>
<span className='para-text text-success fw-bold'>Brand: {product.brand}</span><br />
{/* <span className='para-text text-success fw-bold me-2'>Tags: {product.category} | {product.subCategory}</span> */}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>



        </div>
      </section>

{showAdd && (
  <>
    <section className='bill-area'>
    <div className='bill-inner col-lg-6 col-10 mx-auto'>

<p className='page-title'>Add New Banner</p>

                    <form className="row g-3" onSubmit={handleOfferSubmit}>

<div className='text-center'>
                        <input
                            type="file"
                            className="product-control"
                            id="offerImage"
                            ref={fileInputRef}
                            onChange={handleChange}
                            style={{ display: 'none' }}
                        />
                        <img
                            src={imagePreview || Camera}
                            className='camera-img w-auto cursor-pointer'
                            alt="Logo"
                            onClick={handleImageClick}
                        />
</div>

                        <div className="col-12">
                            <label htmlFor="name" className="profile-label">Offer Name</label>
                            <input
                                type="text"
                                className="product-control"
                                id="name"
                                value={formData.name}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-12">
                            <label htmlFor="tagline" className="profile-label">Offer Tagline</label>
                            <input
                                type="text"
                                className="product-control"
                                id="tagline"
                                value={formData.tagline}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-12">
                            <label htmlFor="description" className="profile-label">Offer Description</label>
                            <textarea
                                type="text"
                                className="product-control"
                                style={{ height: '8em' }}
                                id="description"
                                value={formData.description}
                                onChange={handleChange}
                            >
                            </textarea>
                        </div>

                        {/* Submit Button */}
                        <div className="col-12 text-end">
                            <button type="submit" className="close-btn" onClick={() => setShowAdd(false)}>Close</button>&nbsp;&nbsp;
                            <button type="submit" className="edit-btn">Submit</button>
                        </div>

                    </form>

</div>
</section>
  </>
)}


{showDeleteOffer && (
                <section className='bill-area animate__animated animate__zoomIn' onClick={() => setShowDeleteOffer(false)}>
                    <div className='bill-inner col-lg-6 col-10 mx-auto' onClick={(e) => e.stopPropagation()}>

                        <p className='category-text'>Want to remove this offer?</p>

                        <div
                        className={`banner2-bg py-4 rounded my-3 align-content-center`}
                        style={{ backgroundImage: `url(https://api.hargharmart.com/uploads/${selectedOffer['image']})` }}
                        >
                        <div className="container text-start">
                            <p className="fs-5 fw-semibold">{selectedOffer.offer_tagline}</p>
                            <p className="banner-heading">{selectedOffer.offer_name}</p>
                            <p className="fw-semibold">{selectedOffer.description}</p>
                        </div>
                    </div>

                        <button className='edit-btn px-3 py-1' onClick={() => handleDeleteOffer(selectedOffer.id)}>Yes</button>&nbsp;&nbsp;
                        <button className='close-btn px-3 py-1' onClick={() => setShowDeleteOffer(false)}>No</button>

                    </div>
                </section>
            )}


     {loading && <Loading setLoading={setLoading} />}
       </>
  )
}

export default AdminDashboard
